import React from 'react';
import { ModuleBase, Stack, ResponsiveImage, Text, Box } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';
import { fadeIn, fadeInLeft, fadeInRight } from '@/animations';

const MembershipInfoBlock = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, image, title, preTitle, cards },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: alignment === 'Right' ? '#f1f0e9' : '#fff' } }}
      noPadding
      className="MembershipInfoBlock overflow-hidden py-10 lg:py-18"
    >
      <Stack
        className={classNames(
          'container flex flex-col justify-between gap-5 lg:items-stretch lg:gap-0',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="h-full w-full lg:w-1/2">
          <Text animation={alignment === 'Right' ? fadeInLeft : fadeInRight} className="text-style-tag uppercase">
            {preTitle}
          </Text>
          {title && (
            <Text
              animation={alignment === 'Right' ? fadeInLeft : fadeInRight}
              className="text-style-h3 mt-5 xl:w-[80%]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}

          {cards && (
            <div className="mt-14 flex-col gap-5">
              {cards.map((card, index) => (
                <Box
                  animation={alignment === 'Right' ? fadeInLeft : fadeInRight}
                  key={index}
                  className={classNames(
                    'flex flex-col gap-1 border-black py-5 first:pt-0',
                    index !== 0 &&
                      (alignment === 'Right'
                        ? 'lg:after-extended-line-top border-t lg:border-t-0'
                        : 'border-t border-solid'),
                  )}
                >
                  {card.text && <div className="text-style-h4" dangerouslySetInnerHTML={{ __html: card.text }} />}
                  {card.title && <p className="text-style-body">{card.title}</p>}
                </Box>
              ))}
            </div>
          )}
        </div>
        <div className="relative w-full flex-grow sm:px-14 lg:w-1/2 lg:px-0">
          <div className={classNames(alignment === 'Right' ? 'lg:pr-18 lg:pl-9' : 'lg:pr-9 lg:pl-18', 'h-full')}>
            <div className="h-full overflow-hidden xl:aspect-[575/616]">
              {image && image.desktopImage && (
                <ResponsiveImage
                  animation={fadeIn}
                  image={image.desktopImage}
                  widths={{ xs: 380, sm: 500, md: 520, lg: 368, xl: 576, xxl: 656 }}
                  heights={{ xs: 210, sm: 280, md: 290, lg: 491, xl: 617, xxl: 703 }}
                />
              )}
            </div>
          </div>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default MembershipInfoBlock;
